/*
*  This file environment.dev.ts is part of HROne Inbox. The intelectual property owned by Uneecops Workplace Solution PVT. LTD.
*  CopyrightYear: 2025
*  (C) 2015-2025. All Right reserved. Uneecops Workplace Solution PVT. LTD.
*
*/

import { formIds } from '../app/global/constants/forms.contant';
import { moduleIds } from '../app/global/constants/modules.contant';
import { ouIds } from '../app/global/constants/organization-units.constant';
import { workFlowIds } from '../app/global/constants/workflow.constant';

const placeholders = {
  ph1: '/assets/images/image-placeholder.jpg',
  ph2: './assets/images/employee.png',
  ph3: './assets/images/no-image.png'
};

export const environment = {
  "ZmlyZWJhc2U=": "eyJwcm9qZWN0SWQiOiJocm9uZXY1LXB1c2hub3RpZmljYXRpb24tcHJvZCIsImFwcElkIjoiMTo4NDg3MDA3MzczMzU6d2ViOjM5NjdlNTE2ZTY4OGVhYmNjNTdjYjIiLCJkYXRhYmFzZVVSTCI6Imh0dHBzOi8vaHJvbmV2NS1wdXNobm90aWZpY2F0aW9uLXByb2QuZmlyZWJhc2Vpby5jb20iLCJzdG9yYWdlQnVja2V0IjoiaHJvbmV2NS1wdXNobm90aWZpY2F0aW9uLXByb2QuYXBwc3BvdC5jb20iLCJsb2NhdGlvbklkIjoiYXNpYS1zb3V0aDEiLCJhcGlLZXkiOiJBSXphU3lBZHhiRzJtOXNBWThDdC1zVU83aXVUVE9SYU5faW40cUkiLCJhdXRoRG9tYWluIjoiaHJvbmV2NS1wdXNobm90aWZpY2F0aW9uLXByb2QuZmlyZWJhc2VhcHAuY29tIiwibWVzc2FnaW5nU2VuZGVySWQiOiI4NDg3MDA3MzczMzUiLCJtZWFzdXJlbWVudElkIjoiRy04VDdSWEVQTFpaIn0=",
  "ZmlyZWJhc2VDaGF0": "eyJhcGlLZXkiOiJBSXphU3lCZ1pENDBhdjRnN2F0bzk0ZUpDNlJUMDQtWTZVc1QwR2ciLCJhdXRoRG9tYWluIjoiaHJvbmUtZmlyZWJhc2UtZGV2LmZpcmViYXNlYXBwLmNvbSIsInByb2plY3RJZCI6Imhyb25lLWZpcmViYXNlLWRldiIsInN0b3JhZ2VCdWNrZXQiOiJocm9uZS1maXJlYmFzZS1kZXYuYXBwc3BvdC5jb20iLCJtZXNzYWdpbmdTZW5kZXJJZCI6IjM5OTE4NDY0Mjg3NSIsImFwcElkIjoiMTozOTkxODQ2NDI4NzU6d2ViOmMwZmQzY2MzYTg3YjZhMjBhZmVkMWUifQ==",
  production: false,
  envName: 'production',
  domainCode: 'dgn5',
  workFlowIds: workFlowIds,
  formIds: formIds,
  ouIds: ouIds,
  moduleIds: moduleIds,
  placeholders: placeholders,
  placeholder_xs: '/assets/images/image-placeholder.jpg',
  placeholder_sm: '/assets/images/image-placeholder.jpg',
  placeholder_md: '/assets/images/image-placeholder.jpg',
  apiVersion: 'v1',
  typingEvent: [91, 8, 9],
  users: {
    skip: 0,
    limit: 10
  },
  messages: {
    skip: 0,
    limit: 15
  },
  base_url: "https://app.dev.hrone.work",
  base_auth_url: "https://gateway.dev.hrone.work",
  stripe_base_url: "https://hronedev-subscription.azurewebsites.net",
  isDeployOnGT: false,
  power_bi_url: "https://powerbi.dev.hrone.work",
  microservice_base_url: "https://gateway.dev.hrone.work",
  broadcastUrl: "https://broadcast.dev.hrone.work/hubs/presence",
  hropsDeploymentEnable: true,
  isKBEnable: true,
  isGDPRPointerEnabled: true,
  isChatEnabled: true,
  oneAIGPTUrl: "https://oneai.dev.hrone.work",
  isVariablePaymentPlanEnable: true,
  apiDocumentUrl: "https://apidocs.hrone.cloud",
  isPayComponentEditOptionEnable: true,
  sourceUrl: 'dev.hrone.work',
  legoBaseUrl: "https://keeper.dev.hrone.work",
  legoOrgId: "",
  legoRedirectUrl: 'https://id.dev.hrone.work',
  legoIFrameUrl: 'https://studio.dev.hrone.work',
  isWhatsappOTPEnabled: true,
  allowedPaymentRedirectHosts: ['smartgateway.hdfcuat.bank.in', "smartgateway.hdfc.bank.in"],
  // New Relic Browser Monitoring Configuration
  newRelic: {
    enabled: true,
    accountID: '1321654',
    trustKey: '1321654',
    agentID: '718438601',
    licenseKey: 'fa0d766433',
    applicationID: '718438601'
  },
  loginRedirectUrl: 'https://microweb-host.dev.hrone.work/login',
  redirectToMicro: false,
  aiInterviewerRedirectUrl: 'https://test-interview.hrone.studio'
};
